import { Navigate, useParams } from "react-router";

import { usePortfolioCollection, useProductTypes } from "@/lib/hooks/use-portfolio-collections";

import { TableCardSkeleton } from "../skeleton-loaders";
import { ProductTypesTable } from "./product-types-table";

export default function ProductTypesPage() {
  const { id } = useParams<{ id: string }>();
  const { productTypes, isLoading } = useProductTypes(id!);
  const { collection } = usePortfolioCollection(id!);

  if (isLoading) {
    return <TableCardSkeleton columns={4} />;
  }

  // QL-383 — the tab is hidden while "Use product types" is off; catch direct URLs too.
  if (collection && !collection.productTypesEnabled) {
    return <Navigate to={`/settings/portfolios/${id}/products`} replace />;
  }

  return <ProductTypesTable portfolioCollectionId={id!} productTypes={productTypes} />;
}
